import { request } from '@/utils/axios'

/** 获取当前登录用户详情 */
export function getCurrentUserApi() {
  return request({
    url: 'users/me',
    method: 'get',
  })
}
